import React from "react"
import { SensaiComponentFeatureAccordion } from "../../../gql/generated/graphql"
import { Box, useMediaQuery } from "@mui/system"
import { Grid, Typography } from "@mui/material"
import { GatsbyImage } from "gatsby-plugin-image"
import theme from "../../../material-ui/theme"
import MarkdownContent from "../../ui/MarkdownContent"
import Accordion from "@mui/material/Accordion"
import AccordionSummary from "@mui/material/AccordionSummary"
import AccordionDetails from "@mui/material/AccordionDetails"
import AddIcon from "@mui/icons-material/Add"
import RemoveIcon from "@mui/icons-material/Remove"

const AccordionFeature = ({
  feature,
}: {
  feature: SensaiComponentFeatureAccordion
}) => {
  const [expanded, setExpanded] = React.useState<number>(0)

  const handleChange = (panel: number) => (
    event: React.SyntheticEvent,
    isExpanded: boolean
  ) => {
    setExpanded(isExpanded ? panel : -1)
  }
  const isMobile = useMediaQuery(theme.breakpoints.down("md"))
  const { id, title, entries } = feature

  const image = !entries
    ? null
    : expanded >= 1 && entries && entries.length > expanded
    ? entries[expanded]?.image
    : entries[0]?.image
  return (
    <Box
      sx={{
        padding: !isMobile ? "3rem" : "2rem",
        borderRadius: "1rem",
        position: "relative",
        backgroundColor: "var(--color-white)",
      }}
    >
      <Box
        sx={{
          position: "relative",
          display: "flex",
          justifyContent: "center",
          marginBottom: !isMobile ? "2rem" : "0rem",
          [theme.breakpoints.down("lg")]: {
            h3: {
              fontSize: "1.6rem !important",
              lineHeight: "1.9rem",
            },
          },
        }}
      >
        <Typography
          variant="h3"
          color={"var(--color-gradient-teal)"}
          className={"gradientText"}
          fontSize={"1.8rem"}
          lineHeight={"2.1rem"}
          fontWeight={600}
        >
          {title}
        </Typography>
      </Box>

      <Grid
        data-aos="fade-up"
        container
        spacing={5}
        alignItems={"stretch"}
        justifyContent={"center"}
      >
        <Grid item sm={12} md={6}>
          {image && !isMobile && (
            <GatsbyImage
              image={image.imageFile?.childImageSharp?.gatsbyImageData}
              style={{
                borderRadius: "1rem",
                height: "600px",
              }}
              objectFit="cover"
              objectPosition="50% 50%"
              alt={image.alternativeText ?? ""}
            />
          )}
        </Grid>
        <Grid item sm={12} md={6}>
          <Box
            sx={{
              position: "relative",
              display: "flex",
              flexDirection: "column",
              height: "100%",
              width: "100%",
            }}
          >
            {entries && (
              <Box
                sx={{
                  "& AccordionSummary": {
                    margin: "0px !important",
                    padding: "0.75rem 0",
                  },
                  "& AccordionDetails": {
                    margin: "0px !important",
                    color: "var(--color-grey-4)",
                  },
                }}
              >
                {entries.map((entry, i) => {
                  return (
                    <Accordion
                      key={i}
                      expanded={expanded === i}
                      onChange={handleChange(i)}
                      sx={{ backgroundColor: "#F6F7F8" }}
                    >
                      <AccordionSummary
                        aria-controls="panel1-content"
                        id="panel1-header"
                        expandIcon={
                          expanded === i ? <RemoveIcon /> : <AddIcon />
                        }
                      >
                        <Typography
                          component="h4"
                          fontWeight={600}
                          className="gradientText"
                        >
                          {entry?.title}
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        {image && isMobile && (
                          <GatsbyImage
                            image={
                              image.imageFile?.childImageSharp?.gatsbyImageData
                            }
                            style={{
                              borderRadius: "1rem",
                              height: "400px",
                              margin: "1rem 0",
                            }}
                            objectFit="cover"
                            objectPosition="50% 50%"
                            alt={image.alternativeText ?? ""}
                          />
                        )}
                        <MarkdownContent
                          animate={false}
                          content={entry?.description ?? ""}
                        />
                      </AccordionDetails>
                    </Accordion>
                  )
                })}
              </Box>
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}

export default AccordionFeature
